// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.meeting-menu-container {
  position: relative;
  display: inline-block;
}

.meeting-menu-button {
  background: rgba(255, 255, 255, 0.1);
  border: none;
  color: white;
  font-size: 24px;
  padding: 12px 16px;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.2s, transform 0.1s;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  height: 48px;
}

.meeting-menu-button:hover {
  background: rgba(255, 255, 255, 0.2);
  transform: scale(1.05);
}

.meeting-menu-button:active {
  transform: scale(0.95);
}

.meeting-menu-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: #2d2d2d;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  min-width: 250px;
  overflow: hidden;
  z-index: 1000;
  animation: slideDown 0.2s ease-out;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.meeting-menu-item {
  width: 100%;
  padding: 14px 16px;
  background: transparent;
  border: none;
  color: white;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 12px;
  transition: background-color 0.2s;
}

.meeting-menu-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.meeting-menu-item.danger {
  color: #ff6b6b;
}

.meeting-menu-item.danger:hover {
  background: rgba(255, 107, 107, 0.1);
}

.menu-icon {
  font-size: 18px;
  width: 24px;
  text-align: center;
}

.menu-item-with-submenu {
  position: relative;
}

.submenu-arrow {
  margin-left: auto;
  font-size: 10px;
  transition: transform 0.2s;
}

.submenu {
  position: absolute;
  top: 100%;
  left: 0;
  margin-top: 4px;
  background: #3d3d3d;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
  min-width: 250px;
  max-height: 300px;
  overflow-y: auto;
  z-index: 1001;
  animation: slideDown 0.2s ease-out;
}

.submenu-item {
  padding: 12px 14px;
  font-size: 13px;
}

.submenu-divider {
  height: 1px;
  background: rgba(255, 255, 255, 0.1);
  margin: 4px 0;
}

/* Scrollbar styling for submenu */
.submenu::-webkit-scrollbar {
  width: 6px;
}

.submenu::-webkit-scrollbar-track {
  background: transparent;
}

.submenu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.submenu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

@media (max-width: 768px) {
  .meeting-menu-button {
    padding: 8px;
    width: 40px;
    height: 40px;
    font-size: 20px;
  }

  .meeting-menu-dropdown {
    min-width: 200px;
    right: 0;
    left: auto;
  }

  .meeting-menu-item {
    padding: 12px 14px;
    font-size: 13px;
  }

  .menu-icon {
    font-size: 16px;
    width: 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/MeetingMenu.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,iDAAiD;EACjD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oCAAoC;EACpC,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iCAAiC;AACnC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,eAAe;EACf,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,oCAAoC;EACpC,aAAa;AACf;;AAEA,kCAAkC;AAClC;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,QAAQ;IACR,UAAU;EACZ;;EAEA;IACE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".meeting-menu-container {\n  position: relative;\n  display: inline-block;\n}\n\n.meeting-menu-button {\n  background: rgba(255, 255, 255, 0.1);\n  border: none;\n  color: white;\n  font-size: 24px;\n  padding: 12px 16px;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background-color 0.2s, transform 0.1s;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 48px;\n  height: 48px;\n}\n\n.meeting-menu-button:hover {\n  background: rgba(255, 255, 255, 0.2);\n  transform: scale(1.05);\n}\n\n.meeting-menu-button:active {\n  transform: scale(0.95);\n}\n\n.meeting-menu-dropdown {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: #2d2d2d;\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);\n  min-width: 250px;\n  overflow: hidden;\n  z-index: 1000;\n  animation: slideDown 0.2s ease-out;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.meeting-menu-item {\n  width: 100%;\n  padding: 14px 16px;\n  background: transparent;\n  border: none;\n  color: white;\n  font-size: 14px;\n  text-align: left;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  transition: background-color 0.2s;\n}\n\n.meeting-menu-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.meeting-menu-item.danger {\n  color: #ff6b6b;\n}\n\n.meeting-menu-item.danger:hover {\n  background: rgba(255, 107, 107, 0.1);\n}\n\n.menu-icon {\n  font-size: 18px;\n  width: 24px;\n  text-align: center;\n}\n\n.menu-item-with-submenu {\n  position: relative;\n}\n\n.submenu-arrow {\n  margin-left: auto;\n  font-size: 10px;\n  transition: transform 0.2s;\n}\n\n.submenu {\n  position: absolute;\n  top: 100%;\n  left: 0;\n  margin-top: 4px;\n  background: #3d3d3d;\n  border-radius: 8px;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);\n  min-width: 250px;\n  max-height: 300px;\n  overflow-y: auto;\n  z-index: 1001;\n  animation: slideDown 0.2s ease-out;\n}\n\n.submenu-item {\n  padding: 12px 14px;\n  font-size: 13px;\n}\n\n.submenu-divider {\n  height: 1px;\n  background: rgba(255, 255, 255, 0.1);\n  margin: 4px 0;\n}\n\n/* Scrollbar styling for submenu */\n.submenu::-webkit-scrollbar {\n  width: 6px;\n}\n\n.submenu::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.submenu::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.submenu::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n@media (max-width: 768px) {\n  .meeting-menu-button {\n    padding: 8px;\n    width: 40px;\n    height: 40px;\n    font-size: 20px;\n  }\n\n  .meeting-menu-dropdown {\n    min-width: 200px;\n    right: 0;\n    left: auto;\n  }\n\n  .meeting-menu-item {\n    padding: 12px 14px;\n    font-size: 13px;\n  }\n\n  .menu-icon {\n    font-size: 16px;\n    width: 20px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
